export default __webpack_public_path__ + "static/media/simon.fc0296b1.jpg";